import styled from 'styled-components';

export const StyledQuote = styled.section`

    background: white;
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 9999999;
    inset: 0;
    overflow-y: scroll;
    overflow-x: hidden;

    .close-button-ygen {
        position: absolute;
        top: 40px;
        right: 40px;
    }

    .ContactForm {
        height: 100%;
        display: flex;
        align-items: center;
        .col-md-4{
            align-items: center;
            display: flex
        ;
        }
    }

    @media(max-width: 767px){
        .ContactForm {
            height: auto;
            display: block;
            align-items: unset;
            .col-md-4{
                align-items: unset;
                display: block;
            ;
            }
        }

    }
`;
